import { useQuery, QueryOptions } from 'react-query';
import UnitService from '../../services/unitService';

const useUnitQuery = ({
  unitId,
  propertyId,
  organizationId,
  options,
}: {
  unitId: string,
  propertyId: string,
  organizationId: string,
  options?: QueryOptions,
}) => {
  return useQuery(
    ['unit', unitId, propertyId, organizationId],
    () => {
      const unitService = new UnitService();
      return unitService.getById(propertyId, organizationId, unitId);
    },
    {
      enabled: !!unitId && !!propertyId && !!organizationId,
      ...options,
    },
  );
};

export default useUnitQuery;
